import React from 'react'

import styles from './styles.module.scss'

const InputsWrapper = ({ children }) => {
  return <div className={styles.inputWrapper}>{children}</div>
}

export default InputsWrapper
